import { render, staticRenderFns } from "./CustomerTasksListItem.vue?vue&type=template&id=3750366f&scoped=true&lang=pug&"
import script from "./CustomerTasksListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerTasksListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTasksListItem.vue?vue&type=style&index=0&id=3750366f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3750366f",
  null
  
)

/* custom blocks */
import block0 from "./CustomerTasksListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports